import React from 'react'
import type { PropsWithChildren, FC } from 'react'
import type { Scalars } from '@generated/graphql'

interface Props<D> {
  data: D
  seo: FC<D>
  above: FC<D>
  below: FC<D>
}

export const View = <D extends PropsWithChildren<Props<D>>>(
  props: Scalars['ObjectOrString']
) => {
  return (
    <>
      <props.seo {...props.data} />
      <props.above {...props.data} />
      <props.below {...props.data} />
    </>
  )
}
